import React, {Fragment, useState, useEffect} from 'react';

import * as S from './CommissionReport.styles';

import {REPORT_COMPONENTS} from './../config';

import DateRangePicker from './../../common/Form/DateRangePicker/DateRangePicker';
import dateFormat from 'dateformat';
import {PeriodBody} from './../PeriodBody';
import {Footer} from '../Footer';

import {logPageLoadEvents, logOmniClick} from '@ibibo/analytics';
import {userSelector} from '@ibibo/user-reducer';
import {getCookie} from './../../../../utils/getCookie';
import {useSelector} from 'react-redux';

export default function CommissionReport({data, sendTrackingDataToSdk}) {
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [periodData, updatePeriodData] = useState({});
  const [errorState, updateErrorState] = useState('');

  const userInfoSelector = useSelector(userSelector);
  const ccdeCookie = getCookie('ccde');
  const isGCC = ccdeCookie == 'AE';

  useEffect(() => {
    const {userInfo = {}} = userInfoSelector || {};
    const {account_id = ''} = userInfo;
    logPageLoadEvents('reports:mysettings', {
      eVar15: `myPartner_commissionReport|mypartner`,
      eVar67: `${account_id || ''}`, //mypartner agent id
      prop27: '/agent/transactionreport/',
      eVar37: isGCC
        ? 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng'
        : 'domain_sbu:mypartner|domain_country:india|domain_currency:inr|domain_language:eng',
    });
  }, []);
  const getPeriodOmniId = id => {
    let periodOminId = '';

    switch (id) {
      case 'LAST_QUARTER':
        periodOminId = 'LQ';
        break;
      case 'CURR_QUARTER':
        periodOminId = 'CQ';
        break;
      case 'CURR_FY':
        periodOminId = 'CY';
        break;
      case 'PREVIOUS_FY':
        periodOminId = 'LY';
        break;
      case 'THIS_WEEK':
        periodOminId = 'TW';
        break;
      case 'THIS_MONTH':
        periodOminId = 'TM';
        break;
      default:
        break;
    }
    return periodOminId;
  };

  const renderComponentView = (componentName, componentData) => {
    let subComponentName = componentData?.component;
    switch (subComponentName) {
      case REPORT_COMPONENTS.PERIOD_WITH_BODY:
        return (
          <PeriodBody
            data={componentData?.data}
            classes={componentData?.icon?.iconClasses}
            key={componentName}
            periodData={periodData}
            updatePeriodData={updatePeriodData}
            sendTrackingDataToSdk={sendTrackingDataToSdk}
            onPeriodSelectCb={data => {
              updatePeriodData(data);
              const periodOminId = getPeriodOmniId(data?.id);
              logOmniClick('reports:mysettings:reportSelection:report_type', {
                prop54: `commissionReport_widget_clicked_${periodOminId}`,
                eVar15: `myPartner_commissionReport|mypartner`,
                eVar37: isGCC
                  ? 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng'
                  : 'domain_sbu:mypartner|domain_country:india|domain_currency:inr|domain_language:eng',
              });

              switch (data?.id) {
                case 'THIS_WEEK':
                  sendTrackingDataToSdk?.(
                    {
                      event_detail: {
                        event_name: 'click',
                        event_type: 'user_action',
                        event_value: 'SelectPeriodClicked_thisWeek',
                      },
                    },
                    'COMMISSION_REPORT',
                  );
                  break;

                case 'THIS_MONTH':
                  sendTrackingDataToSdk?.(
                    {
                      event_detail: {
                        event_name: 'click',
                        event_type: 'user_action',
                        event_value: 'SelectPeriodClicked_thisMonth',
                      },
                    },
                    'COMMISSION_REPORT',
                  );
                  break;
                case 'LAST_QUARTER':
                  sendTrackingDataToSdk?.(
                    {
                      event_detail: {
                        event_name: 'click',
                        event_type: 'user_action',
                        event_value: 'SelectPeriodClicked_lastQuarter',
                      },
                    },
                    'COMMISSION_REPORT',
                  );
                  break;
                case 'CURR_FY':
                  sendTrackingDataToSdk?.(
                    {
                      event_detail: {
                        event_name: 'click',
                        event_type: 'user_action',
                        event_value: 'SelectPeriodClicked_currFY',
                      },
                    },
                    'COMMISSION_REPORT',
                  );
                  break;
                default:
                  break;
              }
            }}
            onDownloadClickCb={() => {
              logOmniClick('reports:mysettings:download', {
                prop54: `commissionReport|defined_custom`,
                eVar15: `myPartner_commissionReport|mypartner`,
                eVar37: isGCC
                  ? 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng'
                  : 'domain_sbu:mypartner|domain_country:india|domain_currency:inr|domain_language:eng',
              });
            }}
          ></PeriodBody>
        );

      case REPORT_COMPONENTS.DATE_RANGE_PICKER:
        return (
          <DateRangePicker
            key={componentName}
            startLabel="Start Date"
            endLabel="End Date"
            name={componentName}
            singleDate={false}
            mode={'range'}
            from={from}
            to={to}
            setFrom={setFrom}
            setTo={data => {
              setTo(data);
              updateErrorState('');
              sendTrackingDataToSdk?.(
                {
                  event_detail: {
                    event_name: 'click',
                    event_type: 'user_action',
                    event_value: 'ManualRangeSelected',
                  },
                },
                'COMMISSION_REPORT',
              );
            }}
            errorMessage={errorState}
            isMandatory={false}
          />
        );
      case REPORT_COMPONENTS.TEXT:
        return (
          <S.Para key={componentName} className="">
            {componentData?.primaryText}
          </S.Para>
        );

      default:
        return null;
    }
  };
  const renderComponent = () => {
    return data?.body?.order?.map((componentName, index) => {
      const componentData = data.body?.data[componentName];
      return renderComponentView(componentName, componentData);
    });
  };
  const onClickCb = actions => {
    if (!from || !to) {
      updateErrorState('Please select Start and End Date');
      sendTrackingDataToSdk?.(
        {
          event_detail: {
            event_name: 'click',
            event_type: 'user_action',
            event_value: 'ErrorShown_range_not_selected',
          },
        },
        'COMMISSION_REPORT',
      );
      return;
    }
    actions.forEach(action => {
      if (action?.type === 'API_CALL') {
        const format = 'yyyy-mm-dd';
        const startDate = dateFormat(from, format);
        const endDate = dateFormat(to, format);
        const downloadUrl = `${action?.api?.url}start_date=${startDate}&last_date=${endDate}`;

        window.open(downloadUrl, '_blank');
      }
    });
    sendTrackingDataToSdk?.(
      {
        event_detail: {
          event_name: 'click',
          event_type: 'user_action',
          event_value: 'DownloadCommissionClicked_ManualRange',
        },
      },
      'COMMISSION_REPORT',
    );
  };

  return (
    <Fragment>
      {renderComponent()}
      <Footer data={data?.footer?.ctas} onClickCb={onClickCb}></Footer>
    </Fragment>
  );
}
